module.exports = __webpack_public_path__ + "img/logistics-banner.0532e72e.png";